import PreLoadingGif from '@/assets/images/preLoading.gif';

const PreLoading = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/30 bg-cover">
      <img src={PreLoadingGif} alt="페이지를 불러오는 중" className="w-full h-full object-cover" />
    </div>
  );
};

export default PreLoading;
